var module = angular.module('main.customerorder');

module.component('caCustomerOrderDeliveries',{
    templateUrl: 'main/customerorder/customerordersearch/customerordercontent/customerorderdeliveries.cmp.tpl.html',
    bindings: {
        customerOrder: '<',
        navigated: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($state, $translate, CustomerOrderApiService) {
    var vm = this;

    //Properties
    vm.customerOrder = {};

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.getDeliveryStatusTranslation = getDeliveryStatusTranslation;
    vm.getDeliveryTotal = getDeliveryTotal;
    vm.getOrderedQuantitySum = getOrderedQuantitySum;
    vm.getDeliveredQuantitySum = getDeliveredQuantitySum;

    function onInit() {

    }
    function onChanges() {
        _.forEach(vm.customerOrder.deliveries, function(delivery) {
            delivery.showRows = true;
            _.forEach(delivery.deliveryRows, function(deliveryRow) {
                _.forEach(vm.customerOrder.orderRows, function(orderRow) {
                    if (orderRow.id === deliveryRow.orderRow.id) {
                        deliveryRow.orderRow = angular.copy(orderRow);
                    }
                });
            });
        });
    }

    function setUpGridData() {
    }

    function loadGridData() {
    }

    function getDeliveryStatusTranslation(text) {
        if (text) {
            var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
            return $translate.instant('customerorder.status' + textCapital);
        }
    }

    function getDeliveryTotal(delivery) {
        var sum = 0;
        _.forEach(delivery.deliveryRows, function(deliveryRow) {
            sum += (deliveryRow.orderRow.salesPrice * deliveryRow.deliveredQuantity) - (deliveryRow.orderRow.discount * deliveryRow.deliveredQuantity);
        });
        return sum;
    }

    function getOrderedQuantitySum(delivery) {
        var sum = 0;
        _.forEach(delivery.deliveryRows, function(deliveryRow) {
            sum += deliveryRow.orderedQuantity;
        });
        return sum;
    }

    function getDeliveredQuantitySum(delivery) {
        var sum = 0;
        _.forEach(delivery.deliveryRows, function(deliveryRow) {
            sum += deliveryRow.deliveredQuantity;
        });
        return sum;
    }
}
